// extracted by mini-css-extract-plugin
export default {"component":"marketQuestionForm__component___M935G","textField":"marketQuestionForm__textField___fjMyo"};